import { Viewport } from '@radix-ui/react-toast';

import type { ToastViewportProps } from '@radix-ui/react-toast';

export function ToastContainer({ ...props }: ToastViewportProps) {
	return <Viewport className='z-toast fixed top-3 right-6 w-96 flex flex-col-reverse' {...props} />;
}

export default ToastContainer;
